import comp from "./AddLinkReference";
export default comp;
